const initialState = {
  bool: false
}

const showGeneratedPdfBoxRed = (state = initialState, action) => {
  switch (action.type) {
    case 'SHOW_GENERATED_PDF_BOX': {
      return {
        ...state,
        bool: action.bool
      }
    }
    default: {
      return state
    }
  }
}

export default showGeneratedPdfBoxRed
